/**
 * @generated SignedSource<<b22b17dc27fda3aedec0b37f9d947997>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PublishingStatus = "acknowledged" | "failed" | "inprogress" | "succeeded" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PublishingPart_PublishingV2Fragment$data = {
  readonly canBeAcknowledged: boolean;
  readonly finishedAt: string | null | undefined;
  readonly id: string;
  readonly initiatedAt: string;
  readonly messages: ReadonlyArray<{
    readonly additionalMessage: string | null | undefined;
    readonly message: string;
    readonly timestamp: string;
  }>;
  readonly status: PublishingStatus;
  readonly " $fragmentType": "PublishingPart_PublishingV2Fragment";
};
export type PublishingPart_PublishingV2Fragment$key = {
  readonly " $data"?: PublishingPart_PublishingV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublishingPart_PublishingV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PublishingPart_PublishingV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "initiatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublishingMessageV2",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeAcknowledged",
      "storageKey": null
    }
  ],
  "type": "PublishingV2",
  "abstractKey": null
};

(node as any).hash = "cd68fa224475fc8b7dcb679505642284";

export default node;
